module.exports = __webpack_public_path__ + "img/出口智佳.5b48df3e.jpg";